"use strict";
module.exports = require('./en');



/*****************
 ** WEBPACK FOOTER
 ** ./~/date-names/index.js
 ** module id = 412
 ** module chunks = 0
 **/